import axios from 'axios'
import router from '../router'
import { Toast } from 'vant'
// axios.defaults.withCredentials = true

export const request = (config) => {
  return axios(config)
}

axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 401:
          checkNative()
          break
        case 403:
          break
        case 404:
          break
      }
    }
  }
)
function checkNative () {
  const u = navigator.userAgent
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
  let nowUrl = router.history.current.path
  let appquery = router.history.current.query.isApp
  let iosApp = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
    navigator.userAgent
  )
  if (appquery && appquery == 2) {
    if (isiOS) {
      if (iosApp) {
        console.log('applogin axios')
        window.webkit.messageHandlers.toAppLogin.postMessage(nowUrl)
      } else {
        router.replace({
          path: '/login'
        })
      }
    } else if (isAndroid) {
      if (window.zxzx) {
      // app内
        console.log('applogin axios')
        window.zxzx.toAppLogin(nowUrl)
      } else {
      // 浏览器内
        router.replace({
          path: '/login'
        })
      }
    }
  }
}

export default axios



// WEBPACK FOOTER //
// ./src/utils/axios.interceptor.js